import * as mqtt from 'mqtt';
import { APP_MODE } from 'ice';

const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
const port = location.port ? `:${location.port}` : '';
const URL =
  APP_MODE === 'dev'
    ? 'ws://192.168.0.208:3030/ezbroui'
    : `${protocol}://${location.hostname}${port}/ezbroui`;

const getMqttClient = () => {
  const mqttClient = mqtt.connect(URL, {
    username: 'ezcon',
    password: 'ezmqtt',
  });
  mqttClient.setMaxListeners(0);
  return mqttClient;
};

export default getMqttClient;
